import { BellRinging } from '@phosphor-icons/react';
import { Button, Icon, Text } from '@shh/ui';
import { useEffect, useState } from 'react';
import { useLens } from '../app/lens';
import { useFamily } from '../data/family';
import { enablePush, pushState, type PushState } from '../lib/push';
import { todayText } from '../i18n/today';

const KEY = 'shh.push.asked';

/**
 * Once on "Heute": "Erinnerungen aufs Handy?" – for people with their own login (not the wall),
 * until they said yes or "Später". The same switch lives in Einstellungen → Dieses Gerät.
 */
export function PushPrompt() {
  const f = useFamily();
  const lens = useLens();
  const [state, setState] = useState<PushState>();
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(KEY) === 'done';
    } catch {
      return false;
    }
  });
  useEffect(() => {
    if (!hidden) void pushState().then(setState);
  }, [hidden]);
  const done = () => {
    try {
      localStorage.setItem(KEY, 'done');
    } catch {
      /* ignore */
    }
    setHidden(true);
  };
  if (hidden || lens.isWall || !f.meId || (state !== 'off' && state !== 'install')) return null;

  return (
    <section
      aria-label={todayText.pushLabel}
      className="flex flex-col gap-gap-sm rounded-card bg-accent-secondary-soft p-inset-sm"
    >
      <span className="flex items-center gap-gap-sm font-bold">
        <Icon icon={BellRinging} size="md" className="text-accent-secondary" />
        {todayText.pushTitle}
      </span>
      {state === 'install' ? (
        <Text size="sm">{todayText.pushIphone}</Text>
      ) : (
        <Text size="sm">{todayText.pushText}</Text>
      )}
      <div className="flex flex-wrap gap-gap-sm">
        {state === 'off' && (
          <Button
            icon={BellRinging}
            onPress={() =>
              void enablePush(f.householdId, f.meId).then(
                () => done(),
                () => done(),
              )
            }
          >
            {todayText.switchOn}
          </Button>
        )}
        <Button variant="quiet" onPress={done}>
          {state === 'install' ? todayText.understood : todayText.later}
        </Button>
      </div>
    </section>
  );
}
